import isNil from 'lodash/isNil';

export const validateDateNotInFuture = (
  value: string,
  label: string = 'Date',
): boolean | string => {
  if (value > new Date()) {
    return `${label} cannot be a future date`;
  }
  return true;
};

const hasValue = (value) => !isNil(value) && value !== '';

// Helper function to check if any of the three main identification fields have values
export const hasAnyIdentificationFieldValue = (getValues) => {
  const driversLicenseStateId = getValues('driversLicenseStateId');
  const ssnOrTin = getValues('ssnOrTin');
  const passportNumber = getValues('passportNumber');

  return (
    hasValue(driversLicenseStateId) ||
    hasValue(ssnOrTin) ||
    hasValue(passportNumber)
  );
};

// Same "at least one identification number" rule as the applicant above, for a
// minor. The minor section only collects two of them, so either the Social
// Security Number / TIN or the Alien Registration Number satisfies it -- neither
// is required on its own.
//
// Fields inside the `minors` group receive a getValues scoped to the minor being
// validated, so the unprefixed names below resolve to that minor's own values.
export const hasAnyMinorIdentificationFieldValue = (getValues) => {
  const minorSocialSecurityNumber = getValues('minorSocialSecurityNumber');
  const minorAlienRegistrationNumber = getValues(
    'minorAlienRegistrationNumber',
  );

  return (
    hasValue(minorSocialSecurityNumber) ||
    hasValue(minorAlienRegistrationNumber)
  );
};
